import { createSlice } from "@reduxjs/toolkit";
import { WalletState } from "types/wallet";
import { fetchWalletThunk } from "./thunk";

const initialState: WalletState = {
    wallet: null,
    loading: false,
    error: null,
    last_fetched: null,
    expired: true
}

const walletSlice = createSlice({
    initialState,
    name: 'wallet',
    reducers: {
        markWalletExpired(state) {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchWalletThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchWalletThunk.fulfilled, (state, action) => {
            state.loading = false;
            state.wallet = action.payload.wallet;
            state.last_fetched = Date.now();
            state.expired = false;
        });
        builder.addCase(fetchWalletThunk.rejected, (state, action) => {
            state.loading = false;
            if (action.payload !== 'CACHED') {
                state.error = action.payload || 'Failed to fetch wallet data';
            }
        });
    }
})

export default walletSlice.reducer;
export const { markWalletExpired } = walletSlice.actions;